import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LicenceResponse } from "../../types/licence.definition";
import { RootState } from "../store";

interface LicenceState {
  licence: LicenceResponse | null;
  loading: boolean;
  error: string | null;
  errorCode: string | null;
}

const initialState: LicenceState = {
  licence: null,
  loading: false,
  error: null,
  errorCode: null,
};

const licenceSlice = createSlice({
  name: "licence",
  initialState,
  reducers: {
    fetchLicenceRequest: (
      state,
      _action: PayloadAction<{ facilityId: number }>
    ) => {
      state.loading = true;
      state.error = null;
      state.errorCode = null;
    },
    fetchLicenceSuccess: (state, action: PayloadAction<LicenceResponse>) => {
      state.licence = action.payload;
      state.loading = false;
      state.error = null;
      state.errorCode = null;
    },
    fetchLicenceFailure: (state, action: PayloadAction<{ code: string; message: string }>) => {
      state.loading = false;
      state.error = action.payload.message;
      state.errorCode = action.payload.code;
    },
    clearLicence: (state) => {
      state.licence = null;
      state.loading = false;
      state.error = null;
      state.errorCode = null;
    },
  },
});

export const {
  fetchLicenceRequest,
  fetchLicenceSuccess,
  fetchLicenceFailure,
  clearLicence,
} = licenceSlice.actions;

export default licenceSlice.reducer;

export const selectLicenceState = (state: RootState) => state.licence;
